import {React} from '@lexriver/dome'
import css from './LoadingSpinnerForButton.m.scss'

export const LoadingSpinnerForButton = (attrs:{}) => {
    return <div class={css.spinner}>
        <div class={css.rect1}></div>
        <div class={css.rect2}></div>
        <div class={css.rect3}></div>
        <div class={css.rect4}></div>
        <div class={css.rect5}></div>
    </div>
}